import BlogTitle from './BlogTitle'

export default BlogTitle